import './ccf-queue-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfQueueIconProps extends SvgIconProps  {}

/**
 * CcfQueueIcon used to disply Queue icon in the navigation panel
 * @param props - CcfQueueIconProps
 * @example -- <CcfQueueIcon />
 */
export function CcfQueueIcon(props: CcfQueueIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="Queue" clipPath="url(#clip-Queue)">
        <g id="Group_118156" data-name="Group 118156" transform="translate(0 24020)">
          <rect id="Rectangle_80238" data-name="Rectangle 80238" width="44" height="44" rx="2" transform="translate(0 -24020)" fill="#333333" opacity="0"/>
          <g id="Group_118159" data-name="Group 118159" transform="translate(0 -24020)">
            <g id="Rectangle_80240" data-name="Rectangle 80240" fill="#fff" stroke="#707070" strokeWidth="1" opacity="0">
              <rect width="20" height="20" stroke="none"/>
              <rect x="0.5" y="0.5" width="19" height="19" fill="none"/>
            </g>
            <g id="Group_111794" data-name="Group 111794" transform="translate(0 2.999)">
              <g id="Group_111778" data-name="Group 111778" transform="translate(0 0)">
                <path id="bars" d="M13,14H3a1,1,0,1,1,0-2H13a1,1,0,1,1,0,2Zm0,4H3a1,1,0,1,1,0-2H13a1,1,0,1,1,0,2Zm0-8H3A1,1,0,0,1,3,8H13a1,1,0,0,1,0,2Z" transform="translate(2 -8)" fill="#333333"/>
                <path id="down-arrow" d="M21,14a1,1,0,0,0-1,1v4a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V15a1,1,0,0,0-2,0v4a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V15A1,1,0,0,0,21,14Z" transform="translate(-2 -8)" fill="#333333"/>
              </g>
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>

  );
}

export default CcfQueueIcon;
